export function isAndroid(): boolean {
  return /Android/.test(navigator.userAgent)
}

// This is similar to the code from vueuse, but the PURE annotation on the exported constant
// there seems to sometimes cause it to be completely removed from the bundle.
export function isIOS(): boolean {
  return (
    /iP(?:ad|hone|od)/.test(navigator.userAgent) ||
    // The new iPad Pro Gen3 does not identify itself as iPad, but as Macintosh.
    // https://github.com/vueuse/vueuse/issues/3577
    (navigator.maxTouchPoints > 2 && /iPad|Macintosh/.test(navigator.userAgent))
  )
}

export function isSafari(): boolean {
  return /^((?!Chrome|Android).)*Safari\//.test(navigator.userAgent)
}

export function isApple(): boolean {
  return /^(?:Mac|iPad|iPhone|iPod)/.test(navigator.platform)
}
